angular.module('mean.messages').controller('ArchivesController', ['$scope', 'Global', 'Archives', 'Users', 'MeanUser', '$filter', 
  function($scope, Global, Archives, Users, MeanUser, $filter) {
    $scope.global = Global;
    // $scope.package = {
    //   name: 'archives'
    // };



}]);


// WEBPACK FOOTER //
// ./packages/custom/messages/public/controllers/archives.js